import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Modal, Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import closeIcon from "../../../images/Cross.png"
import "./News.scss";
import moment from "moment/dist/moment";
import noImage from "../../../images/no-image.png"
import NewsImg1 from "../../../images/StaticPage/news-img1.jpg";
import NewsletterForm from "@Components/forms/newsletter-form";
import NewsImg2 from "../../../images/StaticPage/news-img2.jpg";
import NewsImg3 from "../../../images/StaticPage/news-img3.jpg";
import { useStaticQuery, graphql } from "gatsby";
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import ReactMarkdown from "react-markdown"
import HomeGetStart from "@Components/Home/HomeGetStart/HomeGetStart";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

import {ImageModule} from "@Components/common/Image_Module";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const FilterGallery = (props) => {
    // const [scroll, setScroll] = useState(false);
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false);
    useEffect(() => {
        // window.addEventListener("scroll", () => {
        //     // setScroll(window.scrollY === 60)
        //     // if(window.scrollY === 60){
        //         // if(localStorage.setItem('Newsletter', "On")){
        //             setShow(window.scrollY = 60)
        //         //     localStorage.setItem('Newsletter', "On")    
        //         // }

        //     // }
        //   })
        if (localStorage.getItem("Newsletter") === null) {
            setShow(true)
            localStorage.setItem('Newsletter', "On")
        }

    }, [])

    const data = useStaticQuery(graphql`
    query{
      glstrapi {

        blogs(sort:"Date:desc", publicationState: LIVE, where: {Publish: true}) {
            id
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            Title
            URL
            Date
          Banner_Video
          Banner_Image {
            alternativeText
            url
          }
          Category
      
        }
        globalConfig(publicationState: LIVE) {
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            id
            Newsletter_background_Image {
                url
            }
          }
      }
      
    }
    `);

    const [news, setNews] = useState(data.glstrapi?.blogs)
    const [filter, setFilter] = useState("All")
    const clickFilter = (e) => {
        setFilter(e)
    }
    var names = [];
    news.forEach(function (obj) {
        if (names.indexOf(obj.Category) === -1) names.push(obj.Category);
    });
    let processedImages1 = JSON.stringify({});
    if (data.glstrapi?.globalConfig?.imagetransforms?.Image_Transforms) {
        processedImages1 = data.glstrapi?.globalConfig?.imagetransforms.Image_Transforms;
    }
    const ImageRender = ({ alt, image_url, node, ggfx_results }) => { 
        // console.log(data.glstrapi?.blogs, "test");
        return (
          <ImageModule ImageSrc={image_url} attr={{ alt: alt }} ggfx_results={ggfx_results} imagename="blog.Image.smalltile" strapi_id={node.id} />

        //   <ImageTransform imagesources={image_url} renderer="srcSet" imagename="blog.Image.smalltile" attr={{ alt: alt, class: '' }} imagetransformresult={processedImages} id={node.id} />
        )
      }
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <React.Fragment>
                        <section className="news-section">
                            <Container>
                                <Row>
                                    <Col lg={12}>
                                        <div className="content-how-can-we-help">
                                            <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                                                <h2>{props.Title}<span className="stroke-text">{props.Sub_Title}</span></h2></ScrollAnimation>
                                            <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                                                <ReactMarkdown source={props.Content} allowDangerousHtml />
                                            </ScrollAnimation>

                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="fiter-news-categories">

                                            <ul>
                                                <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                                                    <li onClick={() => clickFilter('All')} className={filter === "All" ? "all-news active-category list-tab" : "all-news list-tab"}>All News <span className="news-number">{news?.length}</span></li>
                                                </ScrollAnimation>
                                                {names.map(list => (
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                                                        <li onClick={() => clickFilter(list)} className={filter === list ? "active-category list-tab" : "list-tab"}>{list} <span className="news-number">{news.filter(item => item.Category === list)?.length}</span></li>
                                                    </ScrollAnimation>
                                                ))
                                                }
                                            </ul>

                                        </div>
                                    </Col>
                                </Row>
                                <Row className="filter-item-rows">

                                    {filter === "All" ?
                                        news.map(list => {
                                            let processedImages = JSON.stringify({});
                                            if (list?.imagetransforms?.Image_Transforms) {
                                                processedImages = list.imagetransforms.Image_Transforms;
                                            }
                                            return (
                                                <MotionColumn md={6} lg={4} variants={items}>
                                                    <Link className="news-list" to={list.URL}>
                                                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                            <div className="news-card">
                                                                <div className="news-card-content">
                                                                    <span className="news-date">{moment(list.Date).format('DD MMMM YYYY')}</span>
                                                                    <h6 className="news-heading">{list.Title}</h6>
                                                                </div>
                                                                <div className="item-image-wrrapper img-hover-zoom">
                                                                    {list.Banner_Image?.url ? 
                                                                    // <picture>
                                                                    //     <source media="(min-width:992px)" srcSet={list.Banner_Image?.url} />
                                                                    //     <source media="(min-width:768px)" srcSet={list.Banner_Image?.url} />
                                                                    //     <img src={list.Banner_Image?.url} alt={list.Banner_Image?.alternativeText} />
                                                                    // </picture> 
                                                                    <ImageRender alt={list.Title} processedImages={processedImages} image_url={list?.Banner_Image} node={list} ggfx_results={list.ggfx_results} />
                                                                    : <img src={noImage} alt="News Tiles No image" />
                                                                    }
                                                                    {/* {list.Banner_Image?.url ?
                                 <ImageTransform imagesources={list?.Banner_Image?.url} renderer="srcSet" imagename='blog.Image.smalltile'
                              attr={{ alt: list.Banner_Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={list.id} >

                            </ImageTransform>:
                            <img src={noImage} alt="News Tiles No image" />
                            } */}
                                                                    <span className="news-category-tag">{list.Category}</span>
                                                                </div>
                                                            </div>
                                                        </ScrollAnimation>
                                                    </Link>
                                                </MotionColumn>
                                            )
                                        })
                                        :

                                        news.filter(item => item.Category === filter).map(list => {
                                            let processedImages = JSON.stringify({});
                                            if (list?.imagetransforms?.Image_Transforms) {
                                                processedImages = list.imagetransforms.Image_Transforms;
                                            }
                                            return (
                                                <MotionColumn md={6} lg={4} variants={items}>
                                                    <Link className="news-list" to={list.URL}>
                                                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                            <div className="news-card">
                                                                <div className="news-card-content">
                                                                    <span className="news-date">{moment(list.Date).format('DD MMMM YYYY')}</span>
                                                                    <h6 className="news-heading">{list.Title}</h6>
                                                                </div>
                                                                <div className="item-image-wrrapper img-hover-zoom">
                                                                    {list.Banner_Image?.url ? 
                                                                    // <picture>
                                                                    //     <source media="(min-width:992px)" srcSet={list.Banner_Image?.url} />
                                                                    //     <source media="(min-width:768px)" srcSet={list.Banner_Image?.url} />
                                                                    //     <img src={list.Banner_Image?.url} alt={list.Banner_Image?.alternativeText} />
                                                                    // </picture>
                                                                    <ImageRender alt={list.Title} processedImages={processedImages} image_url={list?.Banner_Image} node={list} ggfx_results={list.ggfx_results} />
                                                                     : <img src={noImage} alt="News Tiles No image" />
                                                                    }

                                                                    {/* {list.Banner_Image?.url ?
                                                                 <ImageTransform imagesources={list?.Banner_Image?.url} renderer="srcSet" imagename='blog.Image.smalltile'
                              attr={{ alt: list.Banner_Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={list.id} >

                            </ImageTransform>
                            :
                            <img src={noImage} alt="News Tiles No image" />
                            } */}
                                                                    <span className="news-category-tag">{list.Category}</span>
                                                                </div>
                                                            </div>
                                                        </ScrollAnimation>
                                                    </Link>
                                                </MotionColumn>
                                            )
                                        })}
                                </Row>
                            </Container>
                            <Modal className="newsletter-popup" backdrop="static" keyboard={false} show={show} onHide={handleClose}>
                                <Modal.Body className="d-flex">
                                    <a className="close-icon" href="javascript:void(0)" onClick={handleClose}><img src={closeIcon} /></a>
                                    
                                    <ImageModule attr={{ alt: data.Image?.alternativeText, className: 'newsletter-bg' }} ImageSrc={data.glstrapi?.globalConfig?.Newsletter_background_Image} ggfx_results={data?.ggfx_results} imagename="global-config.Newsletter_background_Image.smallbg" strapi_id={data.glstrapi?.globalConfig?.id} />

                                    {/* <ImageTransform imagesources={data.glstrapi?.globalConfig?.Newsletter_background_Image?.url} renderer="bgImg"
                                        imagename='global-config.Newsletter_background_Image.smallbg'
                                        attr={{ alt: '', className: 'newsletter-bg' }}
                                        imagetransformresult={processedImages1} id={data.glstrapi?.globalConfig?.id} /> */}

                                    <div className="letter-box">
                                        <h6>Newsletter Subscription</h6>
                                        <h4>Get our news and insights straight into your inbox.</h4>
                                        <NewsletterForm />
                                    </div>
                                </Modal.Body>

                            </Modal>
                        </section>
                        <HomeGetStart nobanner={true} />
                    </React.Fragment>
                </motion.section>
            )}
        </InView>
    )
}

export default FilterGallery;